var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"table","margin":"0 auto"}},[_c('b-spinner',{class:_vm.sizeClass,staticStyle:{"color":"#51cbce","margin":"20px 0"},attrs:{"label":"Spinning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }